import React from "react";
import SmartForm, { Field } from "@insightfulscience/smart-react/SmartForm";
import { useLocale } from "@insightfulscience/smart-react/i18";
import { func, node } from "prop-types";
import Select from "@insightfulscience/atomic-react/Select";
import { validateForm, initialState } from "./form";
import { parseIntFromInput } from "../utils/parseIntFromInput";

export const hasSponsoredSelectOptions = [
	{ value: "Yes", text: "Yes" },
	{ value: "No", text: "No" },
];

const RequestSponsorshipFormFields = ({ children, action }) => {
	const [t] = useLocale("request-sponsorship-form");

	return (
		<SmartForm {...{ validateForm, action }} initialState={initialState} textRender={t}>
			<Field
				fieldClassName="mb-8"
				name="firstName"
				label="FIRST_NAME"
				required
				maxLength={50}
				data-qa-selector="firstName-field"
			/>

			<Field
				fieldClassName="mb-8"
				name="lastName"
				label="LAST_NAME"
				required
				maxLength={50}
				data-qa-selector="lastName-field"
			/>

			<Field
				fieldClassName="mb-8"
				name="email"
				label="EMAIL"
				required
				maxLength={100}
				data-qa-selector="email-field"
			/>

			<Field
				fieldClassName="mb-8"
				name="team"
				label="TEAM_NAME"
				required
				maxLength={50}
				data-qa-selector="team-field"
			/>

			<Field
				type="number"
				fieldClassName="mb-8"
				name="licenses"
				label="LICENSES"
				required
				maxLength={10}
				parseEvent={parseIntFromInput}
				data-qa-selector="licenses-field"
			/>

			<Field
				fieldClassName="mb-8"
				name="hasSponsored"
				label="HAS_SPONSORED"
				required
				maxLength={100}
				data-qa-selector="hasSponsored-field"
				Control={Select}
			>
				<Select.Placeholder disabled>{t("SELECT_PLACEHOLDER")}</Select.Placeholder>
				{Select.renderOptions(
					hasSponsoredSelectOptions,
					({ value }) => value,
					({ text }) => text,
				)}
			</Field>
			{children}
		</SmartForm>
	);
};

RequestSponsorshipFormFields.propTypes = {
	action: func,
	children: node,
};

export default RequestSponsorshipFormFields;
